/**
 * Reads the first worksheet of an Excel file into a rectangular grid of trimmed cell strings.
 *
 * `raw: false` asks SheetJS for the *formatted* text of each cell, so a scale bound typed as the
 * number 5 arrives as the string "5" — exactly what {@link rowsToQuestions} expects. Everything
 * downstream works in strings, keeping the parsing logic free of spreadsheet-specific value types.
 *
 * SheetJS is a heavy dependency and only needed the moment someone actually uploads a file, so it
 * is loaded on demand — this keeps it out of the app's initial bundle.
 */
export async function readWorkbook(file: File): Promise<string[][]> {
  const XLSX = await import('xlsx');
  const data = await file.arrayBuffer();
  const workbook = XLSX.read(data, { type: 'array' });

  const sheetName = workbook.SheetNames[0];
  const sheet = sheetName ? workbook.Sheets[sheetName] : undefined;
  if (!sheet) return [];

  const rows = XLSX.utils.sheet_to_json<unknown[]>(sheet, {
    header: 1,
    blankrows: false,
    defval: '',
    raw: false,
  });

  return rows.map((row) =>
    Array.isArray(row) ? row.map((cell) => (cell == null ? '' : String(cell))) : [],
  );
}
